
import { ProgramModule_map, ProgramModule_withSetState, ProgramModule_runWith, ProgramModule_init, ProgramModule_onError, ProgramModule_withErrorHandler } from "../Fable.Elmish.5.0.2/program.fs.js";
import { Cmd_none } from "../Fable.Elmish.5.0.2/cmd.fs.js";
import { getEnumerator, clear, structuralHash, disposeSafe, equals, isDisposable as isDisposable_1, uncurry3 } from "../fable-library-js.5.0.0/Util.js";
import { class_type } from "../fable-library-js.5.0.0/Reflection.js";
import { Operators_IsNull } from "../fable-library-js.5.0.0/FSharp.Core.js";
import { removeInPlace, item } from "../fable-library-js.5.0.0/Array.js";
import { some, value as value_1 } from "../fable-library-js.5.0.0/Option.js";
import { map } from "../fable-library-js.5.0.0/List.js";
import { useEffect, useSyncExternalStore, useState } from "react";

export function UseElmishHelper_programWithCustomErrorHandler(onError, program) {
    if (onError == null) {
        return program;
    }
    else {
        return ProgramModule_withErrorHandler(onError, program);
    }
}

class Util_ElmishState$3 {
    constructor(programFactory, arg, dependencies) {
        this.arg = arg;
        this.dependencies = dependencies;
        const program = programFactory();
        const queuedMessages = [];
        this.trackedSubscriptionDisposables = [];
        this.finalDispatch = undefined;
        this.lastDisposedModel = undefined;
        this.unmountCleanupAlreadyRan = false;
        this.onError = ProgramModule_onError(program);
        let patternInput_1;
        const patternInput = ProgramModule_init(program)(this.arg);
        patternInput_1 = [[patternInput[0], (msg) => {
            const matchValue = this.finalDispatch;
            if (matchValue == null) {
                void (queuedMessages.push(msg));
            }
            else {
                matchValue(msg);
            }
        }, false, queuedMessages], patternInput[1]];
        this.state = patternInput_1[0];
        this.cmd = patternInput_1[1];
        this.subscribe = ((callback) => {
            let dispose = false;
            ProgramModule_runWith(this.arg, ProgramModule_withSetState((model_5, dispatch_1) => {
                const patternInput_6 = this.state;
                this.finalDispatch = dispatch_1;
                this.state = [model_5, patternInput_6[1], true, queuedMessages];
                if (!(model_5 === patternInput_6[0])) {
                    callback();
                }
            }, ProgramModule_map((_init, _arg) => {
                const patternInput_3 = this.unmountCleanupAlreadyRan ? _init(_arg) : [this.state[0], this.cmd];
                this.cmd = Cmd_none();
                return [patternInput_3[0], patternInput_3[1]];
            }, (update, msg_2, _model) => {
                const latestModel = this.state[0];
                if (dispose) {
                    return [latestModel, Cmd_none()];
                }
                else {
                    return update(msg_2)(latestModel);
                }
            }, uncurry3((x) => x), uncurry3((x_1) => x_1), (subscribe, model_4) => Util_ElmishState$3__mapSubscription(this, subscribe, model_4), (tupledArg) => [(msg_1) => {
                const patternInput_4 = this.state;
                const mustDispose = dispose && Util_ElmishState$3__hasDisposableValue_4E60E31B(this, patternInput_4[0]);
                return tupledArg[0](msg_1) ? true : mustDispose;
            }, (model_3) => {
                if (isDisposable_1(model_3)) {
                    Util_ElmishState$3__disposeLatestModel(this);
                }
                else {
                    tupledArg[1](model_3);
                }
            }], program)));
            return () => {
                dispose = true;
                Util_ElmishState$3__disposeTrackedSubscriptions(this);
            };
        });
    }
}

function Util_ElmishState$3_$reflection(gen0, gen1, gen2) {
    return class_type("Feliz.UseElmish.Util.ElmishState`3", [gen0, gen1, gen2], Util_ElmishState$3);
}

function Util_ElmishState$3_$ctor_Z29FF63CF(programFactory, arg, dependencies) {
    return new Util_ElmishState$3(programFactory, arg, dependencies);
}

function Util_ElmishState$3__get_State(_) {
    return _.state;
}

function Util_ElmishState$3__get_Subscribe(_) {
    return _.subscribe;
}

function Util_ElmishState$3__BeginMountCycle(_) {
    _.unmountCleanupAlreadyRan = false;
}

function Util_ElmishState$3__DisposeOnUnmount(_) {
    if (!_.unmountCleanupAlreadyRan) {
        _.unmountCleanupAlreadyRan = true;
        Util_ElmishState$3__disposeTrackedSubscriptions(_);
        Util_ElmishState$3__disposeLatestModel(_);
    }
}

function Util_ElmishState$3__IsOutdated_1954DBC6(_, arg$0027, dependencies$0027) {
    if (!equals(_.arg, arg$0027)) {
        return true;
    }
    else {
        return !equals(_.dependencies, dependencies$0027);
    }
}

export function Util_ElmishState$3__reportDisposeError(this$, context, ex) {
    this$.onError([context, ex]);
}

export function Util_ElmishState$3__tryGetUnionFields_4E60E31B(this$, value) {
    if (Operators_IsNull(value)) {
        return undefined;
    }
    else {
        const fields = value.fields;
        if (Operators_IsNull(fields)) {
            return undefined;
        }
        else {
            return fields;
        }
    }
}

export function Util_ElmishState$3__hasDisposableValue_4E60E31B(this$, value) {
    const isDisposable = (candidate) => {
        if (isDisposable_1(candidate)) {
            return true;
        }
        else {
            return false;
        }
    };
    if (isDisposable(value)) {
        return true;
    }
    else {
        const matchValue = Util_ElmishState$3__tryGetUnionFields_4E60E31B(this$, value);
        if (matchValue == null) {
            return false;
        }
        else {
            const array = matchValue;
            return array.some(isDisposable);
        }
    }
}

export function Util_ElmishState$3__disposeDisposableValues_4E60E31B(this$, value) {
    let disposed = false;
    const tryDispose = (candidate) => {
        if (isDisposable_1(candidate)) {
            const disposable = candidate;
            disposed = true;
            try {
                disposeSafe(disposable);
            }
            catch (ex) {
                Util_ElmishState$3__reportDisposeError(this$, "Unable to dispose model state value.", ex);
            }
        }
    };
    tryDispose(value);
    const matchValue = Util_ElmishState$3__tryGetUnionFields_4E60E31B(this$, value);
    if (matchValue == null) {
    }
    else {
        const fields = matchValue;
        for (let idx = 0; idx <= (fields.length - 1); idx++) {
            tryDispose(item(idx, fields));
        }
    }
    return disposed;
}

export function Util_ElmishState$3__removeTrackedDisposable_Z5A296901(this$, disposable) {
    removeInPlace(disposable, this$.trackedSubscriptionDisposables, {
        Equals: equals,
        GetHashCode: (x) => (structuralHash(x) | 0),
    });
}

export function Util_ElmishState$3__trackSubscriptionDisposable_Z5A296901(this$, subscriptionDisposable) {
    let disposed = false;
    let trackedDisposableRef = undefined;
    const trackedDisposable_1 = {
        Dispose() {
            if (!disposed) {
                disposed = true;
                if (trackedDisposableRef == null) {
                }
                else {
                    Util_ElmishState$3__removeTrackedDisposable_Z5A296901(this$, trackedDisposableRef);
                }
                try {
                    disposeSafe(subscriptionDisposable);
                }
                catch (ex) {
                    Util_ElmishState$3__reportDisposeError(this$, "Unable to dispose subscription.", ex);
                }
            }
        },
    };
    trackedDisposableRef = trackedDisposable_1;
    void (this$.trackedSubscriptionDisposables.push(trackedDisposable_1));
    return trackedDisposable_1;
}

export function Util_ElmishState$3__disposeTrackedSubscriptions(this$) {
    if (this$.trackedSubscriptionDisposables.length > 0) {
        const activeDisposables = this$.trackedSubscriptionDisposables.slice();
        clear(this$.trackedSubscriptionDisposables);
        for (let idx = 0; idx <= (activeDisposables.length - 1); idx++) {
            disposeSafe(item(idx, activeDisposables));
        }
    }
}

export function Util_ElmishState$3__disposeLatestModel(this$) {
    let matchValue, previous_1;
    const boxedModel = this$.state[0];
    if (((matchValue = this$.lastDisposedModel, (matchValue != null) ? ((value_1(matchValue) === boxedModel) ? ((previous_1 = value_1(matchValue), false)) : true) : true)) && Util_ElmishState$3__disposeDisposableValues_4E60E31B(this$, boxedModel)) {
        this$.lastDisposedModel = some(boxedModel);
    }
}

export function Util_ElmishState$3__mapSubscription(this$, subscribe, model) {
    return map((tupledArg) => [tupledArg[0], (dispatch) => Util_ElmishState$3__trackSubscriptionDisposable_Z5A296901(this$, tupledArg[1](dispatch))], subscribe(model));
}

export function React_useElmish_Z6C327F2E(program, arg, dependencies) {
    const patternInput = useState(() => Util_ElmishState$3_$ctor_Z29FF63CF(program, arg, dependencies));
    const state = patternInput[0];
    if (Util_ElmishState$3__IsOutdated_1954DBC6(state, arg, dependencies)) {
        patternInput[1](Util_ElmishState$3_$ctor_Z29FF63CF(program, arg, dependencies));
    }
    const patternInput_1 = useSyncExternalStore(Util_ElmishState$3__get_Subscribe(state), () => Util_ElmishState$3__get_State(state), () => Util_ElmishState$3__get_State(state));
    const subscribed = patternInput_1[2];
    const queuedMessages = patternInput_1[3];
    const dispatch = patternInput_1[1];
    const dependencies_1 = [state];
    useEffect(() => {
        const setup = (() => {
        Util_ElmishState$3__BeginMountCycle(state);
        return () => {
            Util_ElmishState$3__DisposeOnUnmount(state);
        };
    })();
        return setup;
        }, dependencies_1);;
    useEffect(() => {
        if (subscribed && (queuedMessages.length > 0)) {
            let enumerator = getEnumerator(queuedMessages);
            try {
                while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
                    const msg = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
                    setTimeout(() => {
                        dispatch(msg);
                    });
                }
            }
            finally {
                disposeSafe(enumerator);
            }
            clear(queuedMessages);
        }
    }, [subscribed, queuedMessages]);
    return [patternInput_1[0], dispatch];
}

